import { ITreatmentOfChronicAcromegallyAnalogue } from './TreatmentOfChronicAcromegallyAnalogue.types';

export const initialTreatmentOfChronicAcromegallyAnalogue : ITreatmentOfChronicAcromegallyAnalogue= {
  type: "",
  frequency: "",
  dose: "",
  dateStart: null,
  dateEnd: null,
  dateEndIsActive: false
}